export var getLang = function (_a) {
    var _b;
    var settings = _a.reactPage.settings;
    return (_b = settings.lang) !== null && _b !== void 0 ? _b : 'default';
};
//# sourceMappingURL=setting.js.map